import React from 'react';

const SvgMobile = ({ title, ...props }) => (
  <svg viewBox="0 0 390 390" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M275,0H115c-16.568,0-30,13.432-30,30v330c0,16.568,13.432,30,30,30h160c16.569,0,30-13.432,30-30V30c0-16.568-13.431-30-30-30ZM285,360c0,5.514-4.486,10-10,10H115c-5.514,0-10-4.486-10-10V30c0-5.514,4.486-10,10-10h30v.571c0,11.046,8.954,20,20,20h60c11.046,0,20-8.954,20-20v-.571h30c5.514,0,10,4.486,10,10v330Z" />
  </svg>
);

export default SvgMobile;
